import { render, staticRenderFns } from "./RejectButton.vue?vue&type=template&id=484a3544&"
import script from "./RejectButton.vue?vue&type=script&lang=js&"
export * from "./RejectButton.vue?vue&type=script&lang=js&"
import style0 from "./RejectButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports